"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthorized = exports.defineRules = void 0;
var ability_1 = require("@casl/ability");
var types_1 = require("./types");
var defineRules = function (role, scopes) {
    if (role === void 0) { role = types_1.Role.Public; }
    if (scopes === void 0) { scopes = []; }
    var _a = new ability_1.AbilityBuilder(ability_1.Ability), can = _a.can, build = _a.build, rules = _a.rules;
    defineRulesForRole(can, role);
    defineRulesForScopes(can, scopes);
    defineReadsFromWrites(can, rules);
    return build();
};
exports.defineRules = defineRules;
var isAuthorized = function (ability, permissions) {
    var ands = permissions.map(function (permission) {
        return Object.keys(permission).every(function (subject) {
            return ability.can(permission[subject], types_1.Subject[subject]);
        });
    });
    return ands.some(Boolean);
};
exports.isAuthorized = isAuthorized;
var defineReadsFromWrites = function (can, rules) {
    rules.forEach(function (rule) {
        if (rule["action"] === types_1.Action.Write) {
            can(types_1.Action.Read, rule.subject);
        }
    });
};
var defineRulesForRole = function (can, role) {
    switch (role) {
        case types_1.Role.Admin:
            can(types_1.Action.Write, types_1.Subject.Orders);
            can(types_1.Action.Write, types_1.Subject.OrdersDiscount);
            can(types_1.Action.Write, types_1.Subject.Bundles);
            can(types_1.Action.Write, types_1.Subject.QuotableItems);
            can(types_1.Action.Write, types_1.Subject.Institutions);
            can(types_1.Action.Write, types_1.Subject.InstitutionsResellers);
            can(types_1.Action.Write, types_1.Subject.InstitutionsCreate);
            can(types_1.Action.Write, types_1.Subject.Users);
            can(types_1.Action.Write, types_1.Subject.Books);
            can(types_1.Action.Write, types_1.Subject.Transactions);
            can(types_1.Action.Write, types_1.Subject.Clouds);
            can(types_1.Action.Write, types_1.Subject.Licences);
            can(types_1.Action.Write, types_1.Subject.AppModules);
            can(types_1.Action.Write, types_1.Subject.Admin);
            break;
        case types_1.Role.ResellerAdmin:
            can(types_1.Action.Write, types_1.Subject.Orders);
            can(types_1.Action.Read, types_1.Subject.OrdersDiscount);
            can(types_1.Action.Write, types_1.Subject.Bundles);
            can(types_1.Action.Write, types_1.Subject.QuotableItems);
            can(types_1.Action.Write, types_1.Subject.Institutions);
            can(types_1.Action.Write, types_1.Subject.InstitutionsResellers);
            can(types_1.Action.Write, types_1.Subject.Users);
            can(types_1.Action.Write, types_1.Subject.Books);
            can(types_1.Action.Write, types_1.Subject.Clouds);
            can(types_1.Action.Write, types_1.Subject.ResellerUtils);
            can(types_1.Action.Write, types_1.Subject.Repurchase);
            can(types_1.Action.Write, types_1.Subject.Licences);
            can(types_1.Action.Write, types_1.Subject.Transactions);
            can(types_1.Action.Write, types_1.Subject.Reselleradmin);
            break;
        case types_1.Role.SchoolAdmin:
            can(types_1.Action.Read, types_1.Subject.Orders);
            can(types_1.Action.Write, types_1.Subject.Institutions);
            can(types_1.Action.Read, types_1.Subject.Users);
            can(types_1.Action.Read, types_1.Subject.Books);
            can(types_1.Action.Read, types_1.Subject.Clouds);
            can(types_1.Action.Write, types_1.Subject.Schooladmin);
            break;
        case types_1.Role.Teacher:
            can(types_1.Action.Write, types_1.Subject.Orders);
            can(types_1.Action.Read, types_1.Subject.Bundles);
            can(types_1.Action.Read, types_1.Subject.Institutions);
            can(types_1.Action.Read, types_1.Subject.Users);
            can(types_1.Action.Read, types_1.Subject.Books);
            can(types_1.Action.Read, types_1.Subject.Clouds);
            can(types_1.Action.Read, types_1.Subject.DashboardTeacher);
            can(types_1.Action.Write, types_1.Subject.Teacher);
            break;
        case types_1.Role.Student:
            can(types_1.Action.Read, types_1.Subject.Users);
            can(types_1.Action.Read, types_1.Subject.Books);
            can(types_1.Action.Read, types_1.Subject.Clouds);
            can(types_1.Action.Write, types_1.Subject.Student);
            break;
        case types_1.Role.GroupAdmin:
            can(types_1.Action.Write, types_1.Subject.GroupAdmin);
            break;
        case types_1.Role.Public:
            can(types_1.Action.Write, types_1.Subject.Public);
            break;
        default:
            break;
    }
};
var defineRulesForScopes = function (can, scopes) {
    scopes.forEach(function (scope) {
        switch (scope) {
            case types_1.Scope.U_Order_Discount:
                can(types_1.Action.Write, types_1.Subject.Orders);
                can(types_1.Action.Write, types_1.Subject.OrdersDiscount);
                break;
            case types_1.Scope.U_Sales:
                can(types_1.Action.Write, types_1.Subject.Sales);
                break;
            case types_1.Scope.U_Publisher_Author:
            case types_1.Scope.U_Populate_School_Clouds:
            default:
                break;
        }
    });
};
//# sourceMappingURL=rules.js.map